import { http } from "@/http";

export default {
  list(params) {
    return http.get("/api/v1/admin/biolink/blocks", { params });
  },
  save(payload) {
    return http.put("/api/v1/admin/biolink/blocks", payload);
  }
};